import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules Material utilises
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// Autres modules externes utilises 

// Modules communs utilises
import { BootstrapPopupModule } from '../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';
import { MatPaginatorIntlFr } from '../../shared/pagination/paginator-intl-fr';
import { PannelModule } from '../../shared/pannel/pannel.module';
import { SuggestableInputModule } from '../../shared/suggestable-input/suggestable-input.module';

// Composants metiers
import { GestionEntreprisesComponent } from './components/gestion-entreprises.component';
import { EntreprisesFiltersComponent } from './components/entreprises-filters.component';
import { EntreprisesTableComponent } from './components/entreprises-table.component';
import { EditEntrepriseComponent } from './components/edit-entreprise.component';

// Services metier
import { EntrepriseService } from './services/entreprise.service';
import { AntenneModule } from '../structure/antenne/antenne.module';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,

		MatPaginatorModule,
		MatProgressBarModule,
		MatSortModule,
		MatTableModule,

		BootstrapPopupModule,
		CheckboxListModule,
		FilterableSelectModule,
		JSR310LocalDatesModule,
		PannelModule,
		SuggestableInputModule,
		AntenneModule
	],
	providers: [
		EntrepriseService,
		{
			// Configuration pour que les paginators affichent des libelles en francais
			provide: MatPaginatorIntl,
			useClass: MatPaginatorIntlFr
		},
	],
	declarations: [
		GestionEntreprisesComponent,
		EntreprisesFiltersComponent,
		EntreprisesTableComponent,
		EditEntrepriseComponent
	],
	exports: [
		GestionEntreprisesComponent
	]
})
export class EntrepriseModule {
	constructor() { }
}